import {ueCommonTheme} from '../ueCommonTheme';
import {createEpicTheme} from '@epic-ui/theme/dist/createEpicTheme';
import {UeThemeOptions, UeTheme} from '../ueTheme.types';
import {Overrides} from '@material-ui/core/styles/overrides';
import {makeFormStyleOverrides} from '../ueFormStyles';
import {lighten} from '@material-ui/core/styles/colorManipulator';
import {darkThemeConfig} from '../ueDarkTheme';
import {
    twinColors,
    twinAccentColors,
    gradientColors,
    setTwinmotionOverrides
} from './twinCommonThemeConfig';

const darkColors = {
    background: {
        default: twinColors.dark.carbon,
        paper: twinColors.dark.chrome,
        paperpop: twinColors.dark.titanium
    }
};

export const twinDarkThemeConfig: UeThemeOptions = {
    ...ueCommonTheme,
    name: 'twinDark',
    palette: {
        ...ueCommonTheme.palette,
        type: 'dark',
        background: {
            default: darkColors.background.default,
            defaultShade: (number: number): string => {
                return lighten(darkColors.background.default, number);
            },
            paper: darkColors.background.paper,
            paperpop: darkColors.background.paperpop
        },
        accent: {
            ...twinAccentColors,
            ...twinAccentColors.bright
        },
        text: {
            secondary: '#fff'
        },
        gradient: {
            ...gradientColors
        },
        misc: {
            outline: ueCommonTheme.palette.neutral.pearl
        }
    },
    ue: darkThemeConfig.ue
};

twinDarkThemeConfig.overrides = makeFormStyleOverrides(twinDarkThemeConfig) as Overrides;
setTwinmotionOverrides(twinDarkThemeConfig);

export const twinDarkTheme = createEpicTheme(twinDarkThemeConfig) as UeTheme;
